// extracted by mini-css-extract-plugin
export default {"root":"productList_root__1GGBO"};